import { setupTracking } from '@/utils/tracking.js';

export default ({ app }) => {
  // Ensure this runs only on client-side in production
  if (process.client) {
    const urlParams = new URLSearchParams(window.location.search);
    setupTracking(urlParams,app.$cookies);
  }
};
